<!--
 * @Description  : 专家通项目列表
 * @Author       : 李家宝
 * @Date         : 2022-09-19 14:15:30
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-09-16 15:35:49
 * @FilePath     : \ngs_platform_manage_admin\src\views\project-management\zhuanjia-pro\zhuanjia-project-list.vue
-->
<template>
	<div class="h100 audit">
		<!-- 列表查询页 -->
		<filter-layout @search="searchName" @reset="reset" v-if="!routeQuery" hasMore hasHeader>
			<template #header>
				<el-tabs v-model="typeState" @tab-click="tabChange(typeState)">
					<el-tab-pane :name="null">
						<span slot="label"
							>全部
							<el-badge :value="allNum" class="item"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="1009001003">
						<span slot="label"
							>抽取中
							<el-badge :value="normalNum" class="item"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="1009001004">
						<span slot="label"
							>项目完成
							<el-badge :value="endNum" class="item"> </el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="1009001008">
						<span slot="label"
							>异常终止
							<el-badge :value="abnormalEndNum" class="item"> </el-badge>
						</span>
					</el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="项目名称：" prop="sname">
						<el-input v-model="searchForm.sname" clearable placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="项目类型：" prop="proTypeName">
						<el-select v-model="searchForm.proTypeName" clearable>
							<el-option v-for="item in zjxmlx" :key="item.value" :label="item.sname" :value="item.sname"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="抽取专家库：" prop="libName">
						<el-input v-model="searchForm.libName" clearable placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="专家库用途：" prop="busTypeName">
						<el-select v-model="searchForm.busTypeName" clearable>
							<el-option v-for="(item, index) in ywlx" :key="item.value + index" :label="item.sname" :value="item.sname"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" :model="searchForm" label-width="120px">
					<el-form-item label="创建时间：" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="开标/评审时间：" class="date-time">
						<el-date-picker
							v-model="searchForm.openDateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="w-table-layout w-table-page pdt10">
					<div class="w-table-content" v-show="tableShow">
						<el-table :data="filiterData" height="100%" highlight-current-row row-key="id" border ref="table">
							<el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
							<el-table-column prop="sname" label="项目名称" header-align="center" min-width="150" show-overflow-tooltip>
							</el-table-column>
							<el-table-column
								prop="proTypeName"
								label="项目类型"
								align="center"
								header-align="center"
								min-width="100"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="libName"
								label="抽取专家库"
								align="center"
								min-width="150"
								header-align="center"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="publisherName" label="项目创建方单位" align="center" min-width="150" show-overflow-tooltip>
							</el-table-column>
							<el-table-column
								prop="createUserName"
								label="创建人"
								header-align="center"
								align="center"
								min-width="100"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="extractNum" label="计划抽取" align="center" width="80" show-overflow-tooltip>
								<template slot-scope="scope"> {{ scope.row.extractNum }}人 </template>
							</el-table-column>
							<el-table-column prop="busTypeName" label="专家库用途" align="center" min-width="100" show-overflow-tooltip>
							</el-table-column>

							<el-table-column
								header-align="center"
								align="center"
								prop="openTime"
								label="开标/评审时间"
								min-width="115"
								show-overflow-tooltip
							>
							</el-table-column>
							<el-table-column
								header-align="center"
								align="center"
								prop="createDate"
								min-width="115"
								label="创建时间"
								show-overflow-tooltip
							>
							</el-table-column>

							<el-table-column prop="status" label="状态" min-width="80" align="center" :resizable="false" show-overflow-tooltip>
								<template slot-scope="scope">
									<span :class="dealClass(scope.row.status)">{{ scope.row.status | isFlagFilter }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" min-width="110">
								<template slot="header">操作</template>
								<template slot-scope="scope">
									<el-button type="primary" size="small" round plain class="table-btn" @click="audit(scope.row)">
										<svg-icon icon-class="form-look"></svg-icon> 查看详情
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageList"
							:page-size="pageSize"
							:total="total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<div v-else class="h100 audit operation-layout" :class="{ sHeight: routeQuery == 'projectAuditMsg' || routeQuery == 'projectViewMsg' }">
			<div class="operation-main">
				<zhuanjia-pro-audit ref="childContent" :rowData="rowData"></zhuanjia-pro-audit>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { selectListPage } from 'api/modules/projectManagement'
import zhuanjiaProAudit from './component/zhuanjia-pro-audit'

export default {
	name: 'zhuanjia-project-list',
	components: { zhuanjiaProAudit },
	data() {
		return {
			typeState: null,
			//标签红点
			allNum: 0, //全部
			normalNum: 0, //抽取中
			endNum: 0, //项目完成
			abnormalEndNum: 0, //异常终止
			filiterData: [],
			loading: false,
			//筛选框
			searchForm: {
				status: null, //null 全部 1.取消  1009001003 抽取中  1009001004.项目完成；异常终止，传个空；
				sname: '', //项目名称
				proTypeName: '', //项目类型
				libName: '', // 抽取专家库
				busTypeName: '', // 专家库用途
				publisherName: '', //申请方
				dateArr: [],
				createStartDate: '', //申请开始时间
				createEndDate: '', //申请结束时间
				openDateArr: [],
				openStartDate: '', //开标开始时间
				openEndDate: '' //开标结束时间
			},
			xmbql: [], //项目标签下拉数据
			auditState: '0',
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			auditShow: false, // 审核弹窗的显隐

			dataType: '',
			auditProjectMsg: {}, // 用于接收专家审核传过来的参数
			rowData: {}, // 表格操作当前行数据
			// startDatePicker: this.beginDate(), //限制选择时间的开始
			// endDatePicker: this.processDate(), //限制选择时间的结束
			// startSendDatePicker: this.beginSendDate(),
			// endSendDatePicker: this.processSendDate(),
			certificateList: [
				{
					id: ''
				}
			], //证书列表
			searchToggle: true, //筛选控制
			tableShow: true, //表格显隐控制
			realNameLoading: false,
			isAudit: '' //是否为审核，是则展示审核按钮
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			let params = JSON.parse(this.$getSessionItem('params'))
			if (params && params.hasOwnProperty('libName')) {
				if (this.$getSessionItem('activeTab')) {
					this.typeState = JSON.parse(this.$getSessionItem('activeTab'))
					// this.tabChange(this.typeState)

					// 移除 避免污染
					this.$removeSessionItem('activeTab')
				}

				if (this.$getSessionItem('params')) {
					this.searchForm = JSON.parse(this.$getSessionItem('params'))
					this.currentPage = JSON.parse(this.$getSessionItem('params')).current
					this.pageSize = JSON.parse(this.$getSessionItem('params')).size
					this.auditState = JSON.parse(this.$getSessionItem('params')).status

					// 移除 避免污染
					this.$removeSessionItem('params')
				}
			}
		}
		this.getData()
	},
	filters: {
		isFlagFilter(status) {
			const statusMap = {
				1009001003: '抽取中',
				1009001004: '项目完成',
				1009001008: '异常终止'
			}
			return statusMap[status]
		}
	},
	methods: {
		// 处理状态
		dealClass(data) {
			let msg = ''
			switch (data) {
				case '1009001004':
					msg = 'green-state'
					break
				case '1009001003':
					msg = 'orange-state'
					break
				case '1009001008':
					msg = 'gray-state'
					break
			}
			return msg
		},

		// 关闭loading
		realClose() {
			this.realNameLoading = false
		},

		// tab切换
		tabChange(val) {
			this.currentPage = 1
			this.pageSize = 10
			if (val == '0') {
				this.searchForm.status = null
			} else {
				this.searchForm.status = val
			}
			this.getData()
		},

		// 搜索
		searchName() {
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		//获得列表数据
		getData(isBack) {
			// 创建时间
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.createStartDate = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.createEndDate = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.createStartDate = ''
				this.searchForm.createEndDate = ''
			}

			// 开标/评审时间
			if (this.searchForm.openDateArr && this.searchForm.openDateArr.length > 0) {
				this.searchForm.openStartDate = this.searchForm.openDateArr[0] + ' 00:00:00'
				this.searchForm.openEndDate = this.searchForm.openDateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.openStartDate = ''
				this.searchForm.openEndDate = ''
			}
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			selectListPage(params).then((res) => {
				if (res.operationCode == 1) {
					this.loading = false
					this.filiterData = res.data.ipage.records
					this.currentPage = parseInt(res.data.ipage.current)
					this.total = parseInt(res.data.ipage.total)
					this.allNum = parseInt(res.data['0'])
					this.normalNum = res.data['1009001003']
					this.endNum = res.data['1009001004']
					this.abnormalEndNum = res.data['1009001008']
					this.pageSize = parseInt(res.data.ipage.size)
				}
			})
		},

		//筛选框重置
		reset() {
			this.searchForm.sname = ''
			this.searchForm.proTypeName = ''
			this.searchForm.libName = ''
			this.searchForm.busTypeName = ''
			this.searchForm.publisherName = ''
			this.searchForm.dateArr = []
			this.searchForm.createStartDate = ''
			this.searchForm.createEndDate = ''
			this.searchForm.openDateArr = []
			this.searchForm.openStartDate = ''
			this.searchForm.openEndDate = ''
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		// 点击审核
		audit(data, type) {
			let queryType = 'projectAuditMsg' // 审核页面，支持审核及查看
			let params = Object.assign({}, this.searchForm)
			params.current = this.currentPage
			params.size = this.pageSize
			params.type = this.searchForm.type

			// 存值
			this.$setSessionItem('params', JSON.stringify(params))
			this.$setSessionItem('activeTab', JSON.stringify(this.typeState))

			// 列表数据
			this.rowData = data

			// 页面跳转
			this.$router.push({
				name: 'zhuanjia-project-list',
				query: {
					type: queryType,
					mode: type
				}
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		}
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		...mapState('dict', {
			ywlx: (state) => state.projectDict.ywlx,
			zjxmlx: (state) => state.projectDict.zjxmlx
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},

		// 监听路由参数 --- 回到主界面时刷新查询
		$route(params) {
			let arr = Object.keys(params.query)
			if (arr.length === 0) {
				this.getData()
			}
		}
	}
}
</script>

<style scoped lang="less">
.audit {
	.searchBox {
		padding-top: 8px;
	}
	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}
	/deep/ .el-tabs__item {
		width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0;
		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}
	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}
	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}
	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}
	.auditMsg {
		color: #2671cc;
		cursor: pointer;
	}
	.green,
	.red,
	.orange {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		font-size: 12px;
		border-radius: 5px;
	}
	.green {
		background: #e9f6f2;
		border: 1px solid #bff5e5;
		color: #39c098;
	}
	.red {
		background: #feeff0;
		border: 1px solid #fde2e2;
		color: #f56c6c;
	}
	.orange {
		background: #fdf6ec;
		border: 1px solid #faecd8;
		color: #e7a23c;
	}
	.toolbar {
		position: relative;
		.toolbar-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}
	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}
	.item {
		position: absolute !important;
		right: -15px;
	}
}
.sHeight {
	padding: 0;
}
.colorred {
	color: #f56c6c;
}
</style>
